import { LitElement, html, css } from 'lit'
import { store } from '../store.js'
import { navigate } from '../router.js'
import { takeReturnTo } from '../return-to.js'
import { api, setAccessToken } from '../api.js'
import { authCardStyles } from './auth-styles.js'

// Target of the verification email link. Posts the token to /auth/verify, which
// onboards the client's domain, activates the account, and returns a session —
// so the user lands signed in (§4.3).
class PageVerify extends LitElement {
  static properties = { _state: { state: true } }  // 'verifying' | 'error'

  static styles = authCardStyles

  constructor() {
    super()
    this._state = 'verifying'
  }

  connectedCallback() {
    super.connectedCallback()
    this._verify()
  }

  async _verify() {
    const token = new URLSearchParams(window.location.search).get('token')
    if (!token) { this._state = 'error'; return }
    try {
      const { accessToken, user } = await api.post('/auth/verify', { token })
      setAccessToken(accessToken)
      store.set({ user })
      navigate(takeReturnTo() || '/')
    } catch {
      this._state = 'error'
    }
  }

  render() {
    if (this._state === 'error') {
      return html`
        <div class="card">
          <h1>Verification failed</h1>
          <div class="error">
            This verification link is invalid, expired, or already used.
          </div>
          <div class="links" style="justify-content:center;margin-top:1.25rem">
            <a @click=${() => navigate('/register')}>Register again</a>
            <a @click=${() => navigate('/login')}>Sign in</a>
          </div>
        </div>
      `
    }
    return html`
      <div class="card">
        <h1>Verifying your email…</h1>
        <p class="muted">One moment while we finish setting up your account.</p>
      </div>
    `
  }
}

customElements.define('page-verify', PageVerify)
